import { Navigate, useNavigate, useParams, useRoutes } from "react-router-dom";
import { UserForm } from "./components/Users/UserForm";
import UserList from "./components/Users/UserList";
import { ChangePassword } from "./components/Users/ChangePassword";
import DashboardLayout from "./layouts/dashboard";
import AuthLayout from "./layouts/auth";
import Login from './components/Auth/LoginPage.js/Login'
import ForgotPassword from "./components/Auth/ForgotPassword";
import GeneralLayout from "./pages/GeneralLayout";
import _ from "lodash";
import Dashboard from "./components/Dashboard/Dashboard";
import VerifyEmail from "./components/Auth/VerifyEmail";
import VerifyOTP from "./components/Auth/VerifyOTP";
import { ConfigForm } from "./components/Configurations/ConfigForm";
import TeamsList from "./components/Configurations/TeamsList";
import { NewTeamForm } from "./components/Configurations/NewTeamForm";
import LeagueList from "./components/Configurations/Leagues/leaguesList";
import { LeagueForm } from "./components/Configurations/Leagues/leaguesForm";
import MatchList from "./components/Configurations/Match/MatchList";
import { MatchweekForm } from "./components/Configurations/Match/MatchForm";
import LeagueStatus from "./components/Leagues/leagueStatus";
import { LeaguesForm } from "./components/Leagues/leagueForm";
import Purchases from './components/Purchases/Purchases'
import { PotForm } from './components/PotSetting/PotForm'
import LeagueDetails from "./components/Leagues/LeagueDetails";
import Players from './components/Players/Players'
import AutoFeachFixtures from "./components/Leagues/AutoFetchFixtures";
import Pots from "./components/PotSetting/Pots";
import { WaitlistForm } from "./components/PotSetting/CreatePotForm";
import PotIdDetails from "./components/PotSetting/WaitListPots/PotIdDetails";
import ActivePotId from "./components/PotSetting/ActivePots/ActivePotId";
import ActiveMatchWeek from "./components/PotSetting/ActivePots/ActiveMatchWeek";
import CompletepotsId from "./components/PotSetting/CompletePots/CompletepotsId";
import CompleteMatchWeek from "./components/PotSetting/CompletePots/CompleteMatchWeek";
import CompleteWinnerDetails from "./components/PotSetting/CompletePots/CompleteWinnerDetails";
import { Manualfixtures } from "./components/Leagues/manualFixtures";
import PlayersDetails from "./components/Players/PlayerDetails";
import PlayersIdDetails from "./components/Players/PlayerIdDeatails";
import ChangePlayerDetails from "./components/Players/ChangePlayerDetails";
import Payouts from './components/Payouts/payouts'
import { useEffect, useState } from "react";
import CustomerQuery from "./components/CustomerQuery/CustomerQuery";
import AdvBannersList from "./components/Configurations/AdvBanners/AdvBannersList";
import { AdvBannersForm }  from "./components/Configurations/AdvBanners/AdvBannersForm";

import { base_url } from "./components/backendurl/url";
import Axios from "axios";
import { JackpotsDetails } from "./components/PotSetting/Jackpots/JackpotsDetails";
import GameLeagues from "./components/Configurations/GameLeagues/GameLeagues";
import { ReceiptInvoices } from "./components/Configurations/ReceiptInvoices/ReceiptInvoices";
import { TokenTransferForm } from "./components/Configurations/TokenTransfer/TokenTransfer";
import TokenTransfersList from "./components/TokenTransfers/TokenTransfersList";
import { getMenuPermissions } from "./components/common/PermissionUtility";
import { getCookie } from "./utils/commonFuctions/cookieUtils";
import { RefreshToken } from "./utils/commonFuctions/RefreshToken";
import { ClipLoader } from 'react-spinners'; 
import UserLogs from "./components/UserLogs/UserLogs";
import ServerDowntimeReport from "./components/ServerDowntimeReport/ServerDowntimeReport";
import { DowntimeReportForm } from "./components/ServerDowntimeReport/DowntimeReportForm";
import { ScheduleReportForm } from "./components/Schedule Reports/ScheduleReportForm";
import ScheduleReportList from "./components/Schedule Reports/ScheduleReportList";
import EmailConfiguration from "./components/Configurations/EmailConfiguration/EmailConfiguration";
import InvoicesList from "./components/Invoices/InvoicesList";

// ----------------------------------------------------------------------

// Forces a full remount of UserForm when route or user_uuid changes,
// preventing stale form data when navigating between add/edit/view.
const UserFormRoute = ({ mode }) => {
  const { user_uuid } = useParams();
  return <UserForm key={`${mode}-${user_uuid || 'new'}`} mode={mode} />;
};

export default function AppRouter() {
  const defaultPermissions = ['add_issuecategory',
    'change_issuecategory', 'delete_issuecategory', 'view_issuecategory',
    'add_otp', 'change_otp', 'delete_otp', 'view_otp',
    'add_profile', 'change_profile', 'delete_profile',
    'view_profile', 'add_tickets', 'change_tickets',
    'delete_tickets', 'view_tickets', 'add_user',
    'change_user', 'delete_user', 'view_user',
    'add_activepots', 'change_activepots', 'delete_activepots',
    'view_activepots', 'add_activepredictionshistory', 'change_activepredictionshistory',
    'delete_activepredictionshistory', 'view_activepredictionshistory', 'add_completedpots',
    'change_completedpots', 'delete_completedpots', 'view_completedpots',
    'add_configuredleagues', 'change_configuredleagues', 'delete_configuredleagues',
    'view_configuredleagues', 'add_jackpots', 'change_jackpots',
    'delete_jackpots', 'view_jackpots', 'add_leaguematchweek',
    'change_leaguematchweek', 'delete_leaguematchweek', 'view_leaguematchweek',
    'add_leagues', 'change_leagues', 'delete_leagues',
    'view_leagues', 'add_leagueseason', 'change_leagueseason',
    'delete_leagueseason', 'view_leagueseason', 'add_matches',
    'change_matches', 'delete_matches', 'view_matches',
    'add_matchweek', 'change_matchweek', 'delete_matchweek',
    'view_matchweek', 'add_paymentsreceipts', 'change_paymentsreceipts',
    'delete_paymentsreceipts', 'view_paymentsreceipts', 'add_payout',
    'change_payout', 'delete_payout', 'view_payout', 'add_payoutrequest',
    'change_payoutrequest', 'delete_payoutrequest', 'view_payoutrequest',
    'add_playerpots', 'change_playerpots', 'delete_playerpots',
    'view_playerpots', 'add_playerwinnings', 'change_playerwinnings',
    'delete_playerwinnings', 'view_playerwinnings', 'add_potconfig',
    'change_potconfig', 'delete_potconfig', 'view_potconfig',
    'add_potplayers', 'change_potplayers', 'delete_potplayers',
    'view_potplayers', 'add_pots', 'change_pots',
    'delete_pots', 'view_pots', 'add_predictionlog',
    'change_predictionlog', 'delete_predictionlog', 'view_predictionlog',
    'add_purchaserequest', 'change_purchaserequest', 'delete_purchaserequest',
    'view_purchaserequest', 'add_standings', 'change_standings',
    'delete_standings', 'view_standings', 'add_teams',
    'change_teams', 'delete_teams', 'view_teams',
    'add_waitlistpredictions', 'change_waitlistpredictions', 'delete_waitlistpredictions', 'view_waitlistpredictions',
  'add_advbanners', 'change_advbanners', 'delete_advbanners', 'view_advbanners']

  const [appAccess, setAppAccess] = useState({});
  const [defaultRoute, setDefaultRoute] = useState(null);
  const [isPermissionsLoading, setIsPermissionsLoading] = useState(true);



  const configToken = () => ({
    headers: { Authorization: `Bearer ${getCookie("token")}` },
  });

  const getPermissions = async () => {
    try {
      setIsPermissionsLoading(true); 
      const updatedAccess = {};
      const userpermissions = await Axios.get(`${base_url}/api/accounts/user/me`, configToken());
      
      // Set cookie for 7 days
      const cookieExpirationDays = 7;
      const expires = new Date(Date.now() + cookieExpirationDays * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `menuData=${encodeURIComponent(JSON.stringify(userpermissions.data.menu_permissions))}; expires=${expires}; path=/`;

      userpermissions.data?.permissions.forEach((permission) => {
        if (defaultPermissions.includes(permission)) {
          updatedAccess[permission] = true;
        }
      });
      
      setAppAccess(updatedAccess);

      
      const menuPermissions = getMenuPermissions();
      
      if (menuPermissions) {
        
        const routePriorityOrder = [
          'dashboard',
          'leagueseason',
          'pots', 
          'players',            
          //'users',
          'user',
          'payout', 
          'paymentsreceipts',
          'configurations',
          // 'leagueseason',
          // 'purchases',
          // 'payout',         
          // 'potplayers',     
          // 'customerquery',
          // 'tokentransfer',
          'tickets',
          'tokentransaction',
          'auditlog',
          //'serverreport',
          'schedulerreport',
          'potconfig',
          'configuredleagues',
          'teams',
          'leaguematchweek',
          'game',
          'invoice',
          'advbanner',
          'primary_email',
          'tokentransferlimit',
          'servicestatus'
        ];

        const permissionToRoute = {
          dashboard: "/dashboard",
          pots: "/rounds",
          //users: "/users",
          user: "/users",
          configurations: "/configurations",
          invoice:"/configurations/receipts&invoices",
          potconfig: "/configurations/roundparameters",
          configuredleagues: "/configurations/leagues",
          teams: "/configurations/teams",
          leaguematchweek: "/configurations/matchweeks",
          game: "/configurations/sports&leagues",
          advbanner: "/configurations/advbanners",
          primary_email: "/configurations/emailConfiguration", 
          tokentransferlimit: "/configurations/tokentransfer",
          paymentsreceipts: "/purchases",
          payouts: "/payouts",
          players: "/players",
         // customerquery: "/customer-query",
          // tokentransfer: "/token-transfer",
          tickets: "/customer-query",
          tokentransaction: "/token-transfer",
          leagueseason: "/seasons",
          payout: "/payouts",
          auditlog: "/userlogs",
          //serverreport: "/server-downtime-report",
          schedulerreport: "/schedulereport",
          servicestatus: "/invoices"
        }; 

        
        const firstAvailableRoute = routePriorityOrder.find(
          (routeKey) => menuPermissions[routeKey]?.read && permissionToRoute[routeKey]
        );
        
        if (firstAvailableRoute) {
          setDefaultRoute(permissionToRoute[firstAvailableRoute]);
        } else {
          setDefaultRoute("/dashboard");
        }
      } else {
        setDefaultRoute("/dashboard");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // Token expired — refresh will reload the page with a valid token,
        // or redirect to login if the refresh token is also expired.
        RefreshToken(error, () => {}, () => {});
      } else {
        console.error("Error getting permissions", error);
        setDefaultRoute("/dashboard");
      }
    } finally {
      setIsPermissionsLoading(false); 
    }
  };

  useEffect(() => {
    if (!_.isEmpty(getCookie('token'))) {
      getPermissions();
    } else {
      setIsPermissionsLoading(false); 
    }
  }, []);

  const routes = useRoutes([
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: !_.isEmpty(getCookie('token')) ? (
            defaultRoute ? (
              <Navigate to={defaultRoute} replace />
            ) : (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh'
              }}>
                <ClipLoader color="#3498db" loading={true} size={35} />
              </div>
            )
          ) : (
            <Navigate to="auth/login" replace />
          ),
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "rounds",
          element: <GeneralLayout title="pots" />,
          children: [
            { path: "", element: <Pots /> },
            { path: "add", element: <WaitlistForm mode="new" /> },
            { path: "edit/:id", element: <WaitlistForm mode="edit" /> },
            { path: "view/:id", element: <PotIdDetails mode="view" /> },
            { path: "activeround/view/:id", element: <ActivePotId mode="view" /> },
            { path: "activeround/matchweek/:id", element: <ActiveMatchWeek mode="view" /> },
            { path: "completeround/view/:id", element: <CompletepotsId mode="view" /> },
            { path: "completeround/matchweek/:id", element: <CompleteMatchWeek mode="view" /> },
            { path: "completeround/winner/:id", element: <CompleteWinnerDetails mode="view" /> },
            { path: "jackpots/details/:id", element: <JackpotsDetails mode="view" /> }, 
          ],
        },
        {
          path: "users",
          element: <GeneralLayout title="Users" />,
          children: [
            { path: "", element: <UserList /> },
            { path: "add", element: <UserFormRoute mode="new" /> },
            { path: "edit/:user_uuid", element: <UserFormRoute mode="edit" /> },
            { path: "view/:user_uuid", element: <UserFormRoute mode="view" /> },
            { path: "changepassword/:user_uuid", element: <ChangePassword mode="changepassword" /> },
          ],
        },
        {
          path: "configurations",
          element: <GeneralLayout title="configurations" />,
          children: [
            { path: "", element: <ConfigForm mode='view' /> },
            { path: "roundparameters", element: <ConfigForm mode='edit' /> },
            { path: "leagues", element: <LeagueList /> },
            { path: "leagues/add", element: <LeagueForm mode="new" /> },
            { path: "leagues/view/:id", element: <LeagueForm mode="view" /> },
            { path: "leagues/edit/:id", element: <LeagueForm mode="edit" /> },
            { path: "teams", element: <TeamsList /> },
            { path: "teams/add", element: <NewTeamForm mode="new" /> },
            { path: "matchweeks", element: <MatchList /> },
            { path: "matchweeks/add", element: <MatchweekForm mode="new" /> },
            { path: "sports&leagues", element: <GameLeagues /> },
            { path: "receipts&invoices", element: <ReceiptInvoices /> },
            { path: "tokentransfer", element: <TokenTransferForm mode="new" title="Token Transfer" /> },
            { path: "advbanners", element: <AdvBannersList /> },
            { path: "advbanners/add", element: <AdvBannersForm mode="new" /> },
            { path: "advbanners/edit/:id", element: <AdvBannersForm mode="edit" /> },
            { path: "emailConfiguration", element: <EmailConfiguration /> }
          ],
        },
        {
          path: "seasons",
          element: <GeneralLayout title="Leagues" />,
          children: [
            { path: "", element: <LeagueStatus /> },
            { path: "add", element: <LeaguesForm mode="new" /> },
            { path: "add/autofixture", element: <AutoFeachFixtures /> },
            { path: "add/manualfixture", element: <Manualfixtures /> },
            { path: "details", element: <LeagueDetails mode="new" /> },
            { path: "details/add", element: <PotForm mode="new" /> },
            { path: "details/edit/:user_uuid", element: <PotForm mode="edit" /> }
          ],
        },
        {
          path: "purchases",
          element: <GeneralLayout title="Purchases" />,
          children: [{ path: "", element: <Purchases /> }],
        },
        {
          path: "payouts",
          element: <GeneralLayout title="Payouts" />,
          children: [{ path: "", element: <Payouts /> }],
        },
        {
          path: "players",
          element: <GeneralLayout title="players" />,
          children: [
            { path: "", element: <Players /> },
            { path: "add", element: <ChangePlayerDetails mode="new" /> },
            { path: "edit/:player_uuid", element: <ChangePlayerDetails mode="edit" /> },
            { path: "view/:player_uuid", element: <ChangePlayerDetails mode="view" /> },
            { path: "player_details", element: <PlayersDetails mode="view" /> },
            { path: "player_details/player_id", element: <PlayersIdDetails mode="view" /> },
          ],
        },
        {
          path: "customer-query",
          element: <GeneralLayout title="customer-query" />,
          children: [{ path: "", element: <CustomerQuery /> }],
        },
        {
          path: "token-transfer",
          element: <GeneralLayout title="token-transfer" />,
          children: [{ path: "", element: <TokenTransfersList /> }],
        },
         {
          path: "userlogs",
          element: <GeneralLayout title="user-logs" />,
          children: [{ path: "", element: <UserLogs /> }],
        },
        //  {
        //   path: "server-downtime-report",
        //   element: <GeneralLayout title="server-downtime-report" />,
        //   children: [{ path: "", element: <ServerDowntimeReport /> },
        //     { path: "new", element: <DowntimeReportForm mode="new" /> },
        //   ],
        // },
          {
          path: "schedulereport",
          element: <GeneralLayout title="schedulereport" />,
          children: [{ path: "", element: <ScheduleReportList /> },
             { path: "new", element: <ScheduleReportForm mode="new" /> },
             { path: "edit/:player_uuid", element: <ScheduleReportForm mode="edit" /> },
          ],
        },
         {
          path: "invoices",
          element: <GeneralLayout title="user-logs" />,
          children: [{ path: "", element: <InvoicesList /> }],
        },
      ],
    },
    // Auth routes (outside of DashboardLayout)
    // {
    //   path: "auth",
    //   element: <AuthLayout />,
    //   children: [
    //     { path: "login", element: <Login /> },
    //     { path: "forgot-password", element: <ForgotPassword /> },
    //     { path: "verify-email", element: <VerifyEmail /> },
    //     { path: "verify-otp", element: <VerifyOTP /> }
    //   ],
    // },
  ]);
    
  if (isPermissionsLoading && !_.isEmpty(getCookie('token'))) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <ClipLoader 
          color="#3498db" 
          loading={true} 
          size={50} 
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
          Loading your dashboard...
        </p>
      </div>
    );
  }

  return routes;
}